// Default theme values are found at
// https://mui.com/customization/default-theme/

const THEME = {
  palette: {
    primary: {
      main: '#0059a3',
      contrastText: '#fff',
    },
    secondary: {
      main: '#9abce9',
      contrastText: '#000',
    },
    colorant: {
      main: '#ff5f1f',
      contrastText: '#fff',
    },
    alternative: {
      main: '#357a38',
      contrastText: '#fff',
    },
    backdrop: {
      main: 'rgb(234, 235, 235, 0.75)',
      contrastText: '#000',
    },
  },
};

// Helper method for non-mui components
export const getContrastTextFromHex = (color) => {
  const { primary, secondary, colorant, alternative, backdrop } = THEME.palette;

  switch (color) {
    case primary.main:
      return primary.contrastText;
    case secondary.main:
      return secondary.contrastText;
    case colorant.main:
      return colorant.contrastText;
    case alternative.main:
      return alternative.contrastText;
    case backdrop.main:
      return backdrop.contrastText;
    default:
      return '#000';
  }
};

export default THEME;
